export default __webpack_public_path__ + "static/tiles_top_desktop-db146b26231a4675a1380abc0317a018.png";